import PollForm from "./poll-form";

export default function NewPollView() {
  return <PollForm />;
}
